import { useEffect, useState } from "react";
import type { AdminSettings } from "../../../shared/types";
import { adminGetSettings, adminUpdateSettings } from "../../api";

export default function SettingsTab() {
  const [s, setS] = useState<AdminSettings | null>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    adminGetSettings()
      .then((r) => setS(r.settings))
      .catch((e) => setErr(e instanceof Error ? e.message : "載入失敗"));
  }, []);

  async function save() {
    if (!s) return;
    setBusy(true);
    setMsg(null);
    setErr(null);
    try {
      const r = await adminUpdateSettings(s);
      setS(r.settings);
      setMsg("已儲存");
    } catch (e) {
      setErr(e instanceof Error ? e.message : "儲存失敗");
    } finally {
      setBusy(false);
    }
  }

  if (err) return <div className="alert err">{err}</div>;
  if (!s) return <p>載入中…</p>;

  return (
    <div style={{ maxWidth: 520 }}>
      <h3>系統設定</h3>
      {msg && <div className="alert ok">{msg}</div>}

      <div className="card">
        <label className="check" style={{ marginBottom: 14 }}>
          <input
            type="checkbox"
            checked={s.formOpen}
            onChange={(e) => setS({ ...s, formOpen: e.target.checked })}
          />
          表單開放填寫
        </label>

        <div className="field">
          <label>填寫截止日（含當日；之後學生唯讀，管理員仍可調整）</label>
          <input
            type="date"
            value={s.deadline ?? ""}
            onChange={(e) => setS({ ...s, deadline: e.target.value || null })}
          />
        </div>

        <div className="field">
          <label>最低服務時數門檻</label>
          <input
            type="number"
            min="0"
            step="1"
            value={s.minHours}
            onChange={(e) => setS({ ...s, minHours: Number(e.target.value) })}
          />
        </div>

        <button className="btn primary" disabled={busy} onClick={save}>
          {busy ? "儲存中…" : "儲存設定"}
        </button>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>管理員帳號</h3>
        <p className="muted">
          基於安全，管理員帳號不在網頁上直接建立。請在專案目錄執行：
        </p>
        <pre
          style={{
            background: "#0f1430",
            color: "#dfe3ff",
            padding: 12,
            borderRadius: 10,
            fontSize: 12,
            overflowX: "auto",
          }}
        >
{`node scripts/gen-admin-sql.mjs --username <帳號> \\
  --password '<新密碼>' --out scripts/admin.generated.sql

npx wrangler d1 execute straight_a_attendance --remote \\
  --file=scripts/admin.generated.sql`}
        </pre>
        <p className="muted">重複執行相同帳號即為「改密碼」。</p>
      </div>
    </div>
  );
}
